import script from "./cubeNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./cubeNav.vue?vue&type=script&setup=true&lang=ts"

import "./cubeNav.vue?vue&type=style&index=0&id=3ce06329&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce06329"]])

export default __exports__